const Defaults = {
  stringLength: 8, // used for making pseudo-random strings
};

export function format(first: string, middle: string, last: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export function getItemLabel<T>(item: T, dataLabel?: string): T | string {
  return dataLabel ? item[dataLabel] : (item ?? '');
}

export function getItemValue<T>(item: T, dataId?: string): T {
  return dataId ? item[dataId] : item;
}

export function convertLineBreaks(stringToConvert: string) {
  return stringToConvert.replace('\n', '<br>');
}

export function convertDecimal(numberToConvert: number, oldSeparator: string = '.', newSeparator: string = ',') {
  return String(numberToConvert).replace(oldSeparator, newSeparator);
}

/**
 * Generates an ID-like string.
 * Note that this does not have to be secure or truly random, just unique.
 *
 * @param idPrefix A set prefix to use with the string
 * @param idLength The number of random characters to use in the string
 */
export function makeRandomId(idPrefix: string = '', idLength: number = Defaults.stringLength) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let returnVal = idPrefix ? `${idPrefix}_` : '';
  for (let i = 0; i < idLength; i++) {
    // eslint-disable-next-line sonarjs/pseudo-random
    returnVal += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return returnVal;
}

/**
 * Use this to parse JSON that has trailing commas, or might have HTML quotes.
 * A string like `["a", "b", "c",]` that would otherwise throw an error can now be tolerated.
 * It also repairs overly aggressive escaping of quote marks, which in the past led to problems.
 * @param givenString The potential input that might still have trailing commas.
 */
export function parseDirtyJson(givenString: string) {
  if (!givenString) return [];

  givenString = givenString.replace('&quot;', '"'); // fix the quotes
  givenString = givenString.replace(/,(?=\s*?[}\]])/g, ''); // remove trailing commas (any comma before a closing bracket, brace or the end of the string)
  return JSON.parse(givenString) || [];
}

/**
 * Remove any loading spinner that might be running. Sometime activated by older jQuery scripts.
 * Also ensures that the "main" element has full opacity.
 */
export function removeSpinner(spinnerSelector: string) {
  const spinnerEl = document.querySelector<HTMLElement>(spinnerSelector);
  const mainEl = document.querySelector<HTMLElement>('main');
  spinnerEl?.parentNode?.removeChild(spinnerEl);
  if (mainEl) {
    mainEl.style.opacity = '1';
  }
}

export const wait = async (milliseconds: number): Promise<void> => {
  // TODO: Check if this function returns the correct value
  await new Promise(resolve => setTimeout(resolve, milliseconds));
};

export const toLocaleDateString = (date: string | Date): string => {
  const dateInstance = typeof date === 'string' ? new Date(date) : date;
  return dateInstance?.toLocaleString('de-DE', { dateStyle: 'medium' }) ?? '';
};
